import { mapValues } from 'lodash';
import updateObject from 'modules/taboola-common-frontend-modules/utils/updateObject';
import { COMPONENT_STATUS } from '../../../../../services/constants';
import * as ACTION_TYPES from '../actions';

const propsToPersist = ['shouldShowRemoveVariationModal', 'shouldCrawlOneByOneUrls'];

const initialState = {
    creativeCreatorFormStatus: COMPONENT_STATUS.ACTIVE,
    shouldShowRemoveVariationModal: true,
    shouldCrawlOneByOneUrls: true,
};

const mapValuesConditionally = (obj, updateObj, checkIfShouldUpdate) => {
    return mapValues(obj, values => {
        if (checkIfShouldUpdate(values)) {
            return { ...values, ...updateObj };
        } else {
            return values;
        }
    });
};

export const getUpdatedPreviews = (creativePreviews, thumbnailUrl, update) => {
    return mapValues(creativePreviews, previews => {
        const checkIfShouldUpdate = ({ thumbnailUrl: imgUrl }) => imgUrl === thumbnailUrl;
        return mapValuesConditionally(previews, update, checkIfShouldUpdate);
    });
};

const reducer = {
    [ACTION_TYPES.SET_SHOULD_SHOW_REMOVE_VARIATION_MODAL]: (state, action) =>
        updateObject(state, { shouldShowRemoveVariationModal: action.payload }),
    [ACTION_TYPES.SET_SHOULD_CRAWL_ONE_BY_ONE_URLS]: (state, action) =>
        updateObject(state, { shouldCrawlOneByOneUrls: action.payload }),
};

export { initialState, reducer, propsToPersist };
